import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
/**
 * @description Данный хук предоставляет возможность ставить конкретное состояние для стейта
 *
 * @param {boolean} [initialState=false] - Начальное состояние стейта
 * @return {{setTrue: VoidFunction, state: boolean, setFalse: VoidFunction}}
 */

export function useBooleanState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _React$useState = React.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var setTrue = React.useCallback(function () {
    return setState(true);
  }, []);
  var setFalse = React.useCallback(function () {
    return setState(false);
  }, []);
  return {
    state: state,
    setFalse: setFalse,
    setTrue: setTrue
  };
}